<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ReportsHeader from "@/components/reports-header";
import moment from "moment";
import NoData from "../../../../components/NoData.vue";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ReportsHeader,
    NoData,
  },
  data() {
    return {
      day: moment(new Date(Date.now())).format("YYYY-MM-DD hh:mm:ss A"),

      limit: 20,
      page: 1,
      customers: [],
      transactions: [],
      accountingPeriods: [],
      customer: {},
      accountFilter: {
        accounting_period_id: null,
        from: "",
        to: "",
      },
      selectedCustomer: "",
      search: "",
      totalCredit: 0,
      totalDebit: 0,
      index: 0,
      selectedId: null,
      selectedIndex: null,
      matchedCustomers: null,
      isNoData: false,
    };
  },
  methods: {
    getCustomers(search) {
      this.http
        .post("customers/search", { search, page: 1, limit: 25 })
        .then((res) => {
          if (res.status) {
            this.customers = res.data;
          }
        });
    },
    getReport() {
      this.http
        .post("customers/report", {
          id: this.selectedId,
          accountFilter: this.accountFilter,
        })
        .then((res) => {
          if (res.status) {
            // res.data.sort(t=>t.type=='debit'?-1:1)
            this.transactions = res.data;
            this.totalCredit = 0;
            this.totalDebit = 0;
            this.selectedIndex = this.index;
            this.transactions.forEach((transaction) => {
              if (transaction.type == "credit") {
                this.totalCredit += parseFloat(transaction?.value);
              } else {
                this.totalDebit += parseFloat(transaction?.value);
              }
            });
            if (this.transactions == 0) {
              this.isNoData = true;
            }
          }
        });
    },
    selectCustomer() {
      let customerIndex = this.customers.indexOf(this.selectedCustomer);
      this.index =
        "CUS-" +
        (customerIndex < 10
          ? "000" + customerIndex
          : customerIndex < 100
          ? "00" + customerIndex
          : customerIndex < 1000
          ? "0" + customerIndex
          : customerIndex);
      console.log(this.customer);
      this.selectedId = this.selectedCustomer.id;
    },
    printReport() {
      window.print();
    },
    getAccountingPeriods() {
      this.http.get("accounting-peroids").then((resp) => {
        if (resp) {
          this.accountingPeriods = resp.data;
        }
      });
    },
    showLabel(one) {
      return `${one.id}-${one.name}`;
    },
    searchCustomer(search) {
      this.http
        .post("customers/search", {
          search,
          page: 1,
          limit: 20,
        })
        .then((res) => {
          const selectCustomerInput = document.getElementById("selectUser");
          if (selectCustomerInput) {
            selectCustomerInput.blur();
          }
          this.matchedCustomers = res.data;
        });
    },
  },
  computed: {},
  created() {
    this.getAccountingPeriods();
  },
};
</script>

<template>
  <Layout class="no-print">
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
      :title="$t('customers.report')"
    />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="getReport()">
              <div class="p-3" style="background-color: rgb(246, 247, 248)">
                <div class="row">
                  <div class="col-auto d-flex" style="align-items: flex-end">
                    <div>
                      <label for="" class="d-block">{{
                        $t("customers.select")
                      }}</label>

                      <AutoComplete
                        :completeOnFocus="true"
                        v-model="selectedCustomer"
                        :suggestions="customers"
                        @complete="getCustomers($event.query)"
                        :optionLabel="showLabel"
                        @change="selectCustomer"
                        style="color: #333 !important"
                      />
                      <!-- <div class="row align-items-center">
                        <div class="col-3">
                          <AutoComplete
                            id="selectUser"
                            v-model="selectedCustomer"
                            :suggestions="matchedCustomers"
                            :completeOnFocus="true"
                            :optionLabel="showLabel"
                            @keyup.enter="searchCustomer(selectedCustomer)"
                            @complete="getCustomers($event.query)"
                          />
                        </div>

                        <div class="col-auto">
                          <button
                            class="btn btn-primary"
                            type="button"
                            @click="searchCustomer(selectedCustomer)"
                          >
                            {{ $t("popups.search") }}
                          </button>
                        </div>
                      </div> -->
                    </div>

                    <!-- <div>
                      <label for="" class="d-block"></label>
                      <button
                        type="button"
                        style="margin-inline-start: 4px; height: 40px"
                        @click="selectCustomer"
                        class="btn btn-primary"
                      >
                        {{ $t("popups.select") }}
                      </button>
                    </div> -->
                  </div>
                  <!-- <div class="col-3">

              </div> -->
                  <div class="col d-flex" style="height: 40px">
                    <div class="d-inline">
                      <label for="" class="d-block">{{
                        $t("popups.period")
                      }}</label>

                      <select
                        v-model="accountFilter.accounting_period_id"
                        class="form-select"
                        :disabled="selectedId == null"
                      >
                        <option
                          :value="period.id"
                          v-for="period in accountingPeriods"
                          :key="period"
                        >
                          {{
                            period?.start_date +
                            ` ${this.$i18n.locale == "ar" ? "الى" : "To"} ` +
                            period?.end_date
                          }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="d-inline"
                      style="margin-inline-start: 8px; margin-inline-end: 8px"
                    >
                      <label for="" class="d-block">{{
                        $t("popups.from")
                      }}</label>

                      <input
                        v-model="accountFilter.from"
                        :disabled="selectedId == null"
                        type="date"
                        class="form-control"
                      />
                    </div>
                    <div class="d-inline">
                      <label for="" class="d-block">{{
                        $t("popups.to")
                      }}</label>

                      <input
                        v-model="accountFilter.to"
                        :disabled="selectedId == null"
                        type="date"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-auto d-flex" style="align-items: center">
                    <div></div>
                    <button
                      :disabled="selectedId == null"
                      class="btn btn-success mx-3"
                    >
                      {{ $t("popups.generate_report") }}
                    </button>
                    <button
                      v-if="transactions.length > 0"
                      :title="$t('popups.print')"
                      class="btn btn-success float-end"
                      @click="
                        $store.dispatch('utils/printElement', {
                          elementId: 'customer-statement-report',
                          orientation: 'p',
                        })
                      "
                    >
                      <i class="bx bx-printer"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-3">
        <AutoComplete
          @keyup="getCustomers()"
          v-model="selectedCustomer"
          :suggestions="filteredCustomers"
          @complete="search = $event.query"
          style="color: #333 !important; border-radius: 10px !important"
        />
      </div>
      <div class="col-auto">
        <button @click="getCustomerReport()" class="btn btn-primary">
          {{ $t("popups.search") }}
        </button>
      </div>
      <div class="col" v-if="transactions.length > 0">
        <br />
        <button class="btn btn-success float-end" @click="printReport()">
          <i class="bx bx-printer"></i>
        </button>
      </div>
    </div> -->

    <div class="row mt-4" v-if="transactions.length > 0">
      <div id="customer-statement-report" class="card p-4 card-body">
        <ReportsHeader
          class="mt-5"
          :reportName="$t('reports.customers_statement')"
          :accountNo="selectedIndex + 1"
          :accountName="transactions[0]?.name"
        />

        <div class="table-responsive">
          <table
            class="table table-centered table-nowrap table-striped table-hover align-middle"
            :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
          >
            <thead>
              <tr
                class="text-light"
                style="background-color: #2a3042 !important"
              >
                <!-- <th scope="col">{{ $t("general_ledger.account_id") }}</th> -->
                <th scope="col">{{ $t("customers_report.date") }}</th>
                <th scope="col">{{ $t("popups.ref_no") }}</th>
                <th scope="col">{{ $t("customers_report.descr") }}</th>
                <th scope="col">{{ $t("customers_report.debit") }}</th>
                <th scope="col">{{ $t("customers_report.credit") }}</th>
                <th scope="col">{{ $t("customers_report.balance") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class=""
                v-for="transaction in transactions"
                :key="transaction"
              >
                <!-- <td>{{ transaction.code }}</td> -->
                <td>{{ transaction?.created.split("T")[0] }}</td>
                <td class="text-center">
                  {{
                    transaction?.reference_no ? transaction?.reference_no : "-"
                  }}
                </td>
                <td>
                  {{
                    $i18n.locale == "ar"
                      ? transaction?.descr
                      : transaction?.descr_en
                  }}
                </td>
                <td>
                  {{
                    transaction?.type == "debit"
                      ? parseFloat(transaction?.value).toLocaleString()
                      : ""
                  }}
                </td>
                <td>
                  {{
                    transaction?.type == "credit"
                      ? parseFloat(transaction?.value).toLocaleString()
                      : ""
                  }}
                </td>
                <td></td>
              </tr>

              <tr>
                <td colspan="3"></td>

                <td class="total-style">
                  {{ parseFloat(totalDebit).toLocaleString() }}
                </td>
                <td class="total-style">
                  {{ parseFloat(totalCredit).toLocaleString() }}
                </td>
                <td class="total-style">
                  {{
                    0 > parseFloat(totalDebit) - parseFloat(totalCredit)
                      ? "("
                      : ""
                  }}
                  {{
                    Math.abs(
                      parseFloat(totalDebit) - parseFloat(totalCredit)
                    ).toLocaleString()
                  }}
                  {{
                    0 > parseFloat(totalDebit) - parseFloat(totalCredit)
                      ? ")"
                      : ""
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead>
              <th>{{ $t("reports.report_date") }} :</th>
              <th>
                {{ day }}
              </th>
            </thead>
          </table>
        </div>
      </div>
    </div>
    <NoData v-if="isNoData" />
  </Layout>
</template>
<style scoped>
/*
.table,
td {
  border: 1px solid black;
}
*/
.print {
  display: none;
}
@media print {
  .no-print {
    display: none;
  }
  .print {
    display: block;
  }
}
</style>
